import Controller, { OnAfterFetch, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import BaseController from '../../BaseController';

interface PrivacyNoticeData {
  dsTermo: string;
  nrSequencia: number;
}

@Controller({ component: 'modal-privacy-notice', fragment: 'privacy-notice-detail' })
class PrivacyNoticeDetailsController extends BaseController {

  privacyNoticeResponse!: PrivacyNoticeData;

  @OnMount({ target: 'panel-privacy-notice' })
  onMountPanel(): void {
    const { nrSequencia } = this.historyService.getCurrentRouteParams();
    this.context.set({
      nrSequencia: nrSequencia
    });
  }

  @OnAfterFetch({ target: 'fetch-privacy-notice' })
  onAfterFetchTerms(e: FetchEvent): void {
    this.privacyNoticeResponse = e.data as PrivacyNoticeData;
  }

  @OnClose({ target: 'modal-privacy-notice' })
  onCloseModal(): void {
    this.historyService.back();
  }

}

export default PrivacyNoticeDetailsController;
